import {BigNumber} from "bignumber.js";

const toFloat = (number) => {
  const amount = new BigNumber(String(number).replace(/[^\d.,-]/g, '').replace(',', '.')).toNumber()
  if (isNaN(amount)) return 0
  return parseFloat(amount)
};

const toFixedWithoutZero = (number, n = 3) => {
  if(number === '') {
    return  ''
  }

  const fixedNumber = Number(number).toFixed(n);
  const amount = Number(String(fixedNumber).replace(n === 2 ? '.00' : '.000', ''))
  return isNaN(amount) ? '...' : amount
}

function numberWithSpaces(x) {
  let parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
}

function formatNumberSpace(n) {
  if(!n) {
    return  n
  }
  /**
   * Форматирует число, разделяя тысячи пробелами.
   * @param {number} n - Целое число
   * @return {string} - Строка с отформатированным числом
   */
  return n.toLocaleString('ru-RU');
}


function calculatePercentage(num, total, fixed = 2) {
  if (total === 0) {
    return 0
  }
  const p = parseFloat(Number((num / total) * 100).toFixed(fixed));
  return isNaN(p) ? 0 : p
}

function pStatus(n) {
  if (n >= 99) {
    return '#7CB342'
  }

  if (n > 70) {
    return '#F57C00'
  }

  return '#D32F2F'
}


function formatNumber(num) {
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1) + 'G';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1) + 'M';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(1) + 'K';
  } else {
    return num;
  }
}


function replaceUndefinedWithNull(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      obj[key] = null;
    } else if (typeof obj[key] === 'object') {
      console.log(obj)
      replaceUndefinedWithNull(obj[key]);
    }
  });

  return obj;
}

export {
  replaceUndefinedWithNull,
  toFloat,
  toFixedWithoutZero,
  numberWithSpaces,
  calculatePercentage,
  pStatus,
  formatNumber,
  formatNumberSpace
};




// WEBPACK FOOTER //
// ./src/utils/numberUtils.js